export default {
    '--q-color-grey-darken' : '#D6E1EF',
    '--q-color-primary': '#6380f6',
    '--q-color-primary-2': '#99aeff',

    '--q-color-app-background': '#4D535C',
    '--q-color-app-background-2': '#18191b',
    
    '--q-color-component-background': '#353a40',
    '--q-color-component-background-2': '#121416',
    '--q-color-component-background-3': '#3d3c42',

    '--q-color-component-shadow': 'rgba(232, 237, 243, 0.05)',
    '--q-color-component-shadow-2': 'rgba(2, 3, 3, 0.7)',
    '--q-color-component-shadow-3': 'rgba(248, 249, 249, 0.03)',

    '--q-color-app-title' : '#D6E1EF',
}
